export enum LightColors {
  'skyBlue' = '#3FB9FC',
  'calmLilac' = '#D4C6F9',
  'sunYellow' = '#FFE665',
  'zingyGreen' = '#BBF484',
  'aquaGreen' = '#3BE1CE',
  'warmOrange' = '#FFAF83',
}
